import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import MaterialRadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import fieldLogic from '../logic/fieldsLogic';
import useInputRef from './useInputRef';
import Description from '../controls/Description';
import helpers from '../utils/fieldsHelper';

var RadioGroupInput = function RadioGroupInput(_ref) {
  var value = _ref.value,
      options = _ref.options,
      active = _ref.active,
      fieldId = _ref.fieldId,
      dispatch = _ref.dispatch,
      error = _ref.error,
      control = _ref.control,
      readonly = _ref.readonly,
      description = _ref.description;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 1),
      inputRef = _useInputRef2[0];

  var onChange = function onChange(event) {
    if (!fieldLogic) return;
    fieldLogic.onChange(fieldId, event.target.value, dispatch);
  };

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var onFocus = function onFocus() {
    fieldLogic.onFocus(fieldId, dispatch);
    setFocused(true);
  };

  var onBlur = function onBlur() {
    fieldLogic.onBlur(fieldId, dispatch);
    setFocused(false);
  };

  var className = focused ? "Mui-focused" + (error ? "Mui-error" : "") : "" + (error ? "Mui-error" : "");
  return React.createElement(React.Fragment, null, React.createElement(FormControl, {
    component: "fieldset"
  }, React.createElement(MaterialRadioGroup, {
    value: value || '',
    onChange: onChange,
    ref: inputRef,
    onBlur: onBlur,
    onFocus: onFocus,
    className: className
  }, options.map(function (opt) {
    var content = helpers.getHtmlMarkup(opt.label || opt.value);
    return React.createElement(FormControlLabel, {
      key: opt.value,
      value: opt.value,
      control: control,
      label: React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }),
      labelPlacement: "end",
      disabled: readonly
    });
  }))), React.createElement(Description, {
    error: error,
    description: description
  }));
};

RadioGroupInput.defaultProps = {
  options: [],
  control: React.createElement(Radio, {
    color: "primary"
  }),
  labelPlacement: 'end',
  row: false
};
export default React.memo(RadioGroupInput);